import React from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header/Header";
import "animate.css";
import FullHeight from "../components/FullHeight/FullHeight";
import AboutCanvas from "../components/three/AboutCanvas";
import AboutContainer from "../containers/AboutContainer";

const About = () => {
  // dark theme
  document.body.classList.add("dark");
  const TITLE = "quanle.about";

  //
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Header
        isActive={true}
        logoSource="/images/logo-q-circle.svg"
        current={"about"}
      />
      <AboutCanvas />
      <FullHeight isActive={true} />
      <AboutContainer />
    </>
  );
};

export default About;
